/*jslint evil: true, forin: true */
/**
 * @class Classe permettant de gerer les listes triees par index ou par cle
 * @author GELA 
 * @constructor
 * @param {Array}	arraySource	:	Tableau a deux dimensions pour initialiser la collection ([ [cle1, valeur1],[cle2, valeur2],...] 
 */
export class IsiItemList {

    _oItem: {};
    _aKeys : any[];

    constructor(arraySource?: any[]) {
        /** objet qui va stocker les items dans ses proprietes (acces par cle) 
         * @type {Object} @private */
        this._oItem = {};
        /** tableau qui va stocker les cles (acces par index)
         * @type {Array} @private */
        this._aKeys = [];

        /** initialisation de la liste avec le tableau fourni en parameter */
        if (arraySource) {
            for (var i = 0; i < arraySource.length; i++) {
                // Ajout dans la collection
                this._oItem[arraySource[i][0]] = arraySource[i][1];
                // Ajout dans le tableau de cle
                this._aKeys.push(arraySource[i][0]);
            }
        }
        arraySource = null;
    }

	/** 
	 * Methode publique qui renvoie l'enumeration des cles de la collection 
	 * @type {Object}
	 */
    GetKeyEnumerator() {
        let keyEnum;
		try {
			//TimeTrace.Start("IsiItemList.GetKeyEnumerator");
			keyEnum = this._oItem;
		} catch(error) {
            uiCore.logError("IsiItemList.GetKeyEnumerator", error);
			keyEnum = -1;
        } 
        //ABON Sonar suppression du finally l'erreur n'�tant pas rethrow on fait le returne en dehors 
        // du finally
        //TimeTrace.End("IsiItemList.GetKeyEnumerator");
        return keyEnum;
	}

	/** 
	 * Methode publique qui renvoie le nombre d'elements de la IsiItemList 
	 * @type {Number}
	 */
	Count() {
		var nbKeys;
		try {
			//TimeTrace.Start("IsiItemList.Count");
			nbKeys = this._aKeys.length;
		} catch(error) {
            uiCore.logError("IsiItemList.Count", error);
			nbKeys = 0;
		}
        //ABON Sonar suppression du finally l'erreur n'�tant pas rethrow on fait le returne en dehors 
        // du finally
        //TimeTrace.End("IsiItemList.Count");
        return nbKeys;
	}

	/** 
	 * Methode publique qui renvoie true si l element dont la cle est cle existe 
	 * @param {String} sKey	Cle de l'element recherche
	 * @type {Object}
	 */
	Contains(sKey) {
		try {
			//TimeTrace.Start("IsiItemList.Contains");
			sKey = this._oItem.hasOwnProperty(sKey);
		} catch(error) {
            uiCore.logError("IsiItemList.Contains : Cle = " + sKey, error);
			sKey = false;
		}
        //ABON Sonar suppression du finally l'erreur n'�tant pas rethrow on fait le returne en dehors 
        // du finally
        //TimeTrace.End("IsiItemList.Contains");
        return sKey;
	}

	/** 
	 * Methode publique d'ajout d'un element dans la liste.
	 * Retourne l'element ajoute
	 * @param {String} key		Cle de l'element
	 * @param {Object} value	Element
	 * @type {Object}
	 */
	Add(key, value) {
		var val;
		try {
			//TimeTrace.Start("IsiItemList.Add");
			if (!this._oItem[key]) {
				// Ajout dans la collection
				this._oItem[key] = value;
				// Ajout dans le tableau de cle
				this._aKeys.push(key);
			}
			val = this._oItem[key];
		} catch(error) {
            uiCore.logError("IsiItemList.Add : Key = " + key, error);
			val = -1;
		} 
        //ABON Sonar suppression du finally l'erreur n'�tant pas rethrow on fait le returne en dehors 
        // du finally
        //TimeTrace.End("IsiItemList.Add");
        return val;
	}

	/** 
	 * Methode publique de suppression d'un element dans la liste.
	 * @param {String} sKey		Cle de l'element
	 */
	Remove(sKey) {
		try {
			//TimeTrace.Start("IsiItemList.Remove");
			if (this._oItem.hasOwnProperty(sKey)) {
				// suppression dans le tableau de cle
				this._aKeys = this._aKeys.slice(0, this.IndexOf(sKey)).concat(this._aKeys.slice(this.IndexOf(sKey) + 1));

				// suppression dans la collection
				this._oItem[sKey] = null;
				delete this._oItem[sKey];

			}
		} catch(error) {
            uiCore.logError("IsiItemList.Remove : Cle = " + sKey, error);
		} finally {
			//TimeTrace.End("IsiItemList.Remove");
		}
	}

	/** 
	 * Methode publique qui retourne la position d un element a partir de sa cle
	 * @param {String} sKey		Cle de l'element
	 * @type  {Number}
	 */
	IndexOf(sKey) {
		try {
			//TimeTrace.Start("IsiItemList.Remove");
			var iIndex = 0;
			while (iIndex < this._aKeys.length) {
				if (sKey == this._aKeys[iIndex]) {
					//TimeTrace.End("IsiItemList.Remove");
					return iIndex;
				}
				iIndex++;
			}
			//TimeTrace.End("IsiItemList.Remove");
			return - 1;
		}
		catch(error) {
            uiCore.logError("IsiItemList.IndexOf : Cle = " + sKey, error);
			//TimeTrace.End("IsiItemList.Remove");
			return - 1;
		}
	}

	/** 
	 * Methode publique qui retourne la cle d un element a partir de sa position
	 * @param {Number} index		Index de l'element
	 * @type  {String}
	 */
	KeyOf(index) {
		var key;
		try {
			//TimeTrace.Start("IsiItemList.KeyOf");
			key = this._aKeys[index];
		}
		catch(error) {
            uiCore.logError("IsiItemList.KeyOf", error);
			key = undefined;
        }
        //ABON Sonar suppression du finally l'erreur n'�tant pas rethrow on fait le returne en dehors 
        // du finally
        //TimeTrace.End("IsiItemList.KeyOf");
        return key;
	}

	/** 
	 * Methode publique qui retourne un element a partir de sa cle
	 * @param {String} key		Cle de l'element
	 * @type  {Object}
	 */
	Item(key) {
		var val;
		try {
			//TimeTrace.Start("IsiItemList.Item");
			val = this._oItem[key];
		}
		catch(error) {
            uiCore.logError("IsiItemList.Item : Index = " + key, error);
			val = -1;
		}
        //ABON Sonar suppression du finally l'erreur n'�tant pas rethrow on fait le returne en dehors 
        // du finally
        //TimeTrace.End("IsiItemList.Item");
        return val;
	}

	/** 
	 * Methode publique qui met a jour un element a partir de sa cle
	 * @param {String} sKey		Cle de l'element
	 * @param {Object} oValue	Valeur de l'element
	 */
	setItem(sKey, oValue) {

		try {
			//TimeTrace.Start("IsiItemList.setItem");
			if (this._oItem[sKey]) {
				this._oItem[sKey] = oValue;
			}
		}
        catch (error) {
            uiCore.logError("IsiItemList.Item : Index = " + sKey, error);
		} finally {
			//TimeTrace.End("IsiItemList.setItem");
		}

	}
	/** 
	 * Methode publique qui retourne un element a partir de sa position
	 * @param {Number} index		Index de l'element
	 * @type  {Object}
	 */
	ItemByIndex(index) {
		var val;
		try {
			//TimeTrace.Start("IsiItemList.ItemByIndex");
			val = this._oItem[this._aKeys[index]];
		}
		catch(error) {
            uiCore.logError("IsiItemList.ItemByIndex : Index = " + index, error);
			val = -1;
		} 
       //ABON Sonar suppression du finally l'erreur n'�tant pas rethrow on fait le returne en dehors 
        // du finally
        //TimeTrace.End("IsiItemList.ItemByIndex");
        return val;
	}

	/** 
	 * Methode publique qui retourne echange les positions de 2 items
	 * @param {Number} iOldIndex	Index de l'element avant echange
	 * @param {Number} iNewIndex	Index de l'element apres echange
	 */
	SwapItem(iOldIndex, iNewIndex) {
		var newItem = {};
		var newArray = [];

		try {
			var iIndex = 0;
			for (var sKey in this._oItem) {
				switch (iIndex) {
				case iOldIndex:
					newItem[sKey] = this.ItemByIndex(iNewIndex);
					break;
				case iNewIndex:
					newItem[sKey] = this.ItemByIndex(iOldIndex);
					break;
				default:
                        newItem[sKey] = this._oItem[sKey];
					break;
				}
				newArray.push(sKey);
				iIndex++;
			}

			this._oItem = newItem;
			this._aKeys = newArray;
		}
		catch(error) {
            uiCore.logError("IsiItemList.prototype.SwapItem : oldIndex = " + iOldIndex + " , newIndex = " + iNewIndex, error);
		}
	}

	/**
	 * Methode publique de liberation de la memoire  
	 */
	dispose() {
		//TimeTrace.Start("IsiItemList.dispose");
		for (var sKey in this._oItem) {
			// on brise les references
			if (this._oItem[sKey].dispose) {
				this._oItem[sKey].dispose();
			}
			this._oItem[sKey] = null;
			delete this._oItem[sKey];
		}
		delete this._oItem;
		delete this._aKeys;
		//delete this._oItem;
		//delete this._aKeys;
		//TimeTrace.End("IsiItemList.dispose");
	}

	/** 
	 * Methode publique qui vide la collection IsiItemList
	 */
	Clear() {
		//TimeTrace.Start("IsiItemList.Clear");
		this.dispose();
		this._oItem = {};
		this._aKeys = [];
		//TimeTrace.End("IsiItemList.Clear");
	}

	/**
	 * @author	lbri
	 * Effectue un tri de la collection.
	 */
	Sort(compareFunc) {
		//TimeTrace.Start("IsiItemList.Sort");
		var oKey = this._oItem;

		function cf(a, b) {
			return compareFunc(oKey[a], oKey[b]);
		}

		this._aKeys.sort(cf);

		//TimeTrace.End("IsiItemList.Sort");
	}
};